// $18, $13.50, $1,080. Accepts a Prisma Decimal or a price string too.
export const usd = (value: number | string | { toString(): string }) => {
  const amount = Number(value)
  return `$${amount.toLocaleString("en-US", {
    minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
    maximumFractionDigits: 2,
  })}`
}
